import { jsx as s, jsxs as m } from "react/jsx-runtime";
import { s as a, A as t } from "../../AmwayBusinessLinksItem-8d942e3b.mjs";
const c = ({ quickLinksData: e, title: n }) => /* @__PURE__ */ s("div", { className: a["amway-business-link-container"], "data-testid": "amway-business-link-test-id", "data-pod-name": "commerce", children: /* @__PURE__ */ m("div", { className: a["amway-business-link-wrapper"], children: [
  /* @__PURE__ */ s("h2", { className: a["title-section"], children: n }),
  /* @__PURE__ */ s("div", { className: a["amway-business-link-items-section"], children: e.map((i) => /* @__PURE__ */ s(t, { images: i.images, linkdata: i.linkdata }, `${i.linkdata}`)) })
] }) });
export {
  c as default
};
//# sourceMappingURL=AmwayBusinessLinks.js.map
